__turbopack_context__.v({
  "cardCvcContainer": "StripeCardElements-module__MEkVcG__cardCvcContainer",
  "cardExpiryContainer": "StripeCardElements-module__MEkVcG__cardExpiryContainer",
  "cardInputContainer": "StripeCardElements-module__MEkVcG__cardInputContainer",
  "cardNumberContainer": "StripeCardElements-module__MEkVcG__cardNumberContainer",
  "cardSideContainer": "StripeCardElements-module__MEkVcG__cardSideContainer",
  "stripeElement": "StripeCardElements-module__MEkVcG__stripeElement",
});
